export default defineNuxtPlugin(async nuxtApp => {
  const authStore = useAuthUser();
  const refreshTokenExpiresAt = useCookie<number | null>('refreshTokenExpiresAt');

  try {
    if (refreshTokenExpiresAt.value !== null && refreshTokenExpiresAt.value > Date.now()) {
      await authStore.loadUser();
    } else if (refreshTokenExpiresAt.value !== null) {
      authStore.clearUser();
    }
  } catch (e) {
    console.log('cant load user', e)
  }
})
